import "./App.css";
import Claimpage from "./pages/ClaimPage/ClaimPage";
import GlobalContextProvider from "./Contexts/GlobalContext";

function App() {
  return (
    <GlobalContextProvider>
      <div className="App relative">
        <div className="video__wrapper absolute z-[-1] h-full w-full">
          <video
            src="https://mintnft.today/videos/Screen2.mp4"
            id="bgvideo"
            autoPlay
            loop
            playsInline
            className="h-full w-full object-cover"
          ></video>
        </div>
        <Claimpage />
      </div>
    </GlobalContextProvider>
  );
}

export default App;
